import { AUTH_ERRORS } from "@/common/errors";
import { AlertMessage } from "@/components/ui/AlertMessage";
import { t } from "i18next";

interface MFAMessagesProps {
  errorId: string | null;
}

export const MFAMessages = (props: MFAMessagesProps): JSX.Element => {
  if (props.errorId == null) {
    return <></>;
  }

  if (props.errorId == AUTH_ERRORS.MULTI_FACTOR_REQUIRED) {
    return (
      <AlertMessage
        description={t("error.auth.needVerificationCode")}
        title="Multi-factor authentication is activated"
        variant="info"
      />
    );
  } else if (props.errorId == AUTH_ERRORS.INVALID_VERIFICATION_CODE) {
    return (
      <AlertMessage
        description={t("error.auth.invalidVerificationCode")}
        title="Error"
        variant="destructive"
      />
    );
  } else if (props.errorId == AUTH_ERRORS.INVALID_CREDENTIALS) {
    return (
      <AlertMessage
        description={t("error.auth.invalidCredential")}
        title="Error"
        variant="destructive"
      />
    );
  } else if (props.errorId == AUTH_ERRORS.WRONG_PASSWORD) {
    return (
      <AlertMessage
        description={t("error.auth.passwordWrong")}
        title="Error"
        variant="destructive"
      />
    );
  } else {
    return (
      <AlertMessage
        description={t("common.error")}
        title=""
        variant="destructive"
      />
    );
  }
};
